import usePathname from "@/hooks/usePathname"
import { Link } from "@inertiajs/react"
import clsx from "clsx"

const links = [
  {
    href: "/admin",
    label: "Analytics",
  },
  {
    href: "/admin/users",
    label: "Manage users",
  },
  {
    href: "/admin/embed",
    label: "Embed",
  },
  {
    href: "/admin/puzzles",
    label: "Puzzles",
  },
  {
    href: "/admin/promotions",
    label: "Promotions",
  },
]

const AdminNavigation = () => {
  const pathname = usePathname()

  return (
    <nav className="padding flex gap-x-8 overflow-x-auto border-b border-gray-200 bg-white">
      {links.map((link) => {
        const current = pathname === link.href

        return (
          <Link
            key={link.href}
            href={link.href}
            className={clsx(
              "group relative px-1 py-4 text-base leading-6 font-medium whitespace-nowrap",
              current ? "text-gray-900" : "text-gray-500 hover:text-gray-900"
            )}
          >
            <div
              className={clsx(
                "absolute inset-x-0 bottom-0 h-1 rounded-t",
                current
                  ? "bg-chessdrop-500"
                  : "bg-transparent group-hover:bg-gray-200"
              )}
            />
            {link.label}
          </Link>
        )
      })}
    </nav>
  )
}

export default AdminNavigation
